<!--
 * @Description: 侧边栏多选框
 * @Author: youme
 * @LastEditors: youme
 * @Date: 2020-06-18 12:44:38
 * @LastEditTime: 2020-07-29 09:42:06
-->
<template>
  <label>
    <input
      :disabled="disable"
      :checked="value === label && 'checked'"
      class="show-input"
      style="display: none"
      type="radio"
      :name="name"
      @change="handleChange"
    >
    <div class="show-label" :style="{paddingLeft: `${30 + 26 * (level - 1)}px`, cursor: disable?'auto':'pointer'}">{{ label }}</div>
  </label>
</template>

<script>
export default {
  name: 'FlankCheckbox',
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    level: {
      type: Number,
      default: 1
    },
    value: {
      type: String,
      default: ''
    },
    disable: {
      type: Boolean,
      default: false
    },
    onChange: {
      type: Function,
      default: _ => {}
    }
  },
  methods: {
    handleChange() {
      this.$emit('input', this.label)
      this.onChange(this.label)
    }
  }
}
</script>

<style>
.show-label {
  height: 45px;
  line-height: 45px;
  border-left: 4px solid transparent;
}
.show-input:checked + .show-label {
  border-left-color: #446fb0;
  color: #075d99;
}
</style>
